import React, { Fragment, useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import $ from 'jquery';
import AOS from 'aos';
const { config } = require('../../api/api');




function SanadMotorRenewPolicy() {

    
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    const vendor_key = 'c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==';
    const api_headers = {
        'Authorization': 'Bearer ' + vendor_key,
        'Content-Type': 'application/json' // Ensure you're sending JSON
    }
    const base_url = config.baseURL;
    const redirecturl = config.redirectURL;


    const { t } = useTranslation();

 const [isHidePage,setIsHidePage]=useState("");
    const [sanadDetails,setSanadDetails]=useState(null);
    const [openPaymentOption,setOpenPaymentOption]=useState(false);

      const [quoteDetails,setQuoteDetails]=useState(null);
      const [vehicleDetails,setVehicleDetails]=useState(null);
      const [insuredDetails,setInsuredDetails]=useState(null);
      const [transactionDetails,setTransactionDetails]=useState(null);
      const civilNoRef=useRef(null);
      const quoteRef=useRef(null);
      const regNoRef=useRef(null);
      const regMarkRef=useRef(null);
      const [error,setError]=useState({
         civil_no:"",
        quote_id:"",
        registration_mark:"",
        registration_number:""
      });

      const [formData,setFormData]=useState({
        civil_no:"",
        quote_id:"",
        registration_mark:"",
        registration_number:""

      })
      const [loading,setLoading]=useState(false); 
      const [buttonClicked,setButtonClicked]=useState("quote_id");
      const [submitBtnClicked,setSubmitBtnClicked]=useState(false);

    const reg_type = ["Oman Plate", "GCC Plate", "Import", "Export"];
    const reg_mark = [
          "10", "11", "12", "14", "15", "16", 
          "A A", "B K", "D D", "H W", "A D", "M", "A R", "H H", 
          "L K", "H A", "B M", "BANK", "C D", "D A", "Inspection", 
          "M B", "M S", "MUSCAT", "R A", "R H", "T", "T B", "W A", 
          "1", "2", "3", "4", "5", "6", "7", "8", "9", "L D", "M L", 
          "M Y", "Y M", "Y R", "M W", "R R", "T A", "T B A", "Y", 
          "A W", "K B", "L A", "K H", "M D", "M K", "R W", "Y W", 
          "A Y", "B B", "B H", "D H", "D Y", "H", "I N T L", "K", 
          "D R", "D S", "H Y", "IMPORT", "J", "K A", "B R", "B S", 
          "D", "D W", "H K", "H M", "H R", "R", "T T", "Y A", "Y B", 
          "R K", "R S", "W", "Y D", "Y Y", "K K", "S S", "Y S", "A", 
          "B", "B D", "A B", "A K", "A S", "B W", "B Y", "D K", 
          "H D", "H S", "M A", "A M", "M M", "M R", "R M", "S", 
          "S H", "W B", "W K", "T H", "T D", "R Y", "W W", "L B", 
          "L A", "L H", "B A", "M H", "17", "18", "19", "20", "21", 
          "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", 
          "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", 
          "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", 
          "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", 
          "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", 
          "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", 
          "82", "83", "84", "85", "86", "87", "88", "89", "90", "91", 
          "92", "999", "UAE", "Dubai", "Abu Dhabi", "Fujairah", "Sharjah", 
          "Qatar", "Kuwait", "KSA", "Ras Al - Khaimah", "Umm Al - Quwain", 
          "Ajman", "Bahrain"
        ];

          const selectOpt1=useRef(null);

       useEffect( () => {
          debugger;
            // update sanad data in superjet
            const urlSearchString = window.location.search;
            const uparams = new URLSearchParams(urlSearchString);
            const sanadUserName = uparams.get('SANADUSERNAME');
            const sanadRequesteeName = uparams.get('REQUESTEENAME');
            const sanadUserMobileNumber = uparams.get('REQUESTEEMOBILENO');
            const sanadReferenceNumber = uparams.get('SANADREFNUMBER');
            const sanadCivilIDNumber = uparams.get('REQUESTEECIVILNO');
            const sanadAccessToken = uparams.get('SANADACCESSTOKEN');
            const sanad_ServiceRequestId = uparams.get('SERVICEREQUESTID');
            const sanad_TransDate = uparams.get('TRANSDATE');
            const sanad_ReturnUrl = uparams.get('RETURNURL');
            const sanad_ErrorUrl = uparams.get('ERRORURL');
            const sanad_BackUrl = uparams.get('BACKURL');
            const sanad_Language = uparams.get('LANGUAGE');
           
          
            
            let sanad_details={
              sanad_user_name:sanadUserName,
              sanad_request_name:sanadRequesteeName,
              mobile_no:sanadUserMobileNumber,
              sanad_reference_no:sanadReferenceNumber,
              sanad_civil_no:sanadCivilIDNumber,
              sanad_request_id:sanad_ServiceRequestId,
              trans_date:sanad_TransDate,
              return_url:sanad_ReturnUrl,
              error_url:sanad_ErrorUrl,
              back_url:sanad_BackUrl,
              language:sanad_Language
              
            }
    
            if (sanadAccessToken === "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluQHNhbmFkLmNvbSIsInBhc3N3b3JkIjoiMTIzNCIsImlhdCI6MTcyODA1MjA0NywiZXhwIjoxNzI4MDUyOTQ3fQ.ucyIy6q6ovSDstXZL1zO-9swTAGYFeypV0uo8_rQJJc") {
                setIsHidePage('success');
                setSanadDetails(sanad_details);
            } else {
                setIsHidePage('fail');
            }
            // var sanad_urls_data = {
            //     'back_url': sanad_BackUrl,
            //     'return_url': sanad_ReturnUrl,
            //     'error_url': sanad_ErrorUrl,
            // }
            // debugger
            //    sessionStorage.setItem("sanadUrlData", JSON.stringify(sanad_urls_data));
            // const expiryDate = new Date();
            // expiryDate.setTime(expiryDate.getTime() + (1 * 60 * 60 * 1000));
            // Cookies.set('sanadUrlData', JSON.stringify(sanad_urls_data), { expires: expiryDate });
           
        }, []);


        const handleChange=(e)=>{

            const {name,value}=e.target;
            const trimValue=value.trimStart();
            setFormData((prev)=>({...prev,[name]:trimValue}));


        }
        useEffect(() => {
          const $select = $(selectOpt1.current);
        
          // Initialize Select2
          $select.select2({ width: "resolve"})
        
          // Define event handlers
          const handleSelect = (e) => {
            debugger
            // handleChangeRegMark("registration_mark", e.params?.originalSelect2Event?.data?.id);
        
          };
        
          const handleClose = (e) => {
            debugger
            handleValidationRegMark("registration_mark", e.params?.originalSelect2Event?.data?.id);
            // handleChangeRegMark("registration_mark", e.params?.originalSelect2Event?.data?.id);
          };
        
          // Attach handlers
          $select.on('select2:select',(e)=> handleSelect(e));
                    //   $(selectOpt1.current).on('select2:select', (e) => {
          
          $select.on('select2:close',(e) => handleClose(e));
        
          // Cleanup
          return () => {
            $select.off('select2:select', handleSelect);
            $select.off('select2:close', handleClose);
            $select.select2('destroy');
          };
        }, [reg_mark]);

         const handleValidationRegMark=(name,value)=>{
            const trimValue=value;
            debugger
  if(name==="registration_mark" ){
                debugger
                if(!trimValue || trimValue==="--Select--" || trimValue==="--يختار--"){
                  setError((prev)=>({...prev,[name]:"Registration mark is required."}))
    setFormData((prev)=>({...prev,registration_mark:""}))
             
                return;
                }
                else{
                  setError((prev)=>({...prev,[name]:""}));
    setFormData((prev)=>({...prev,registration_mark:trimValue}))

                return;
                }
              }  
        }

        const handleValidation=(e)=>{
          const {name,value}=e.target;
            const trimValue=value.trimStart();
            if(name==="civil_no"){
                if(!trimValue){
                setError((prev)=>({...prev,[name]:"Civil no is required."}))
                return;
                }
                 else if(trimValue.length<5){
                setError((prev)=>({...prev,[name]:"Civil no required should be minimum 5 digit"}))

                }
                else{
                   setError((prev)=>({...prev,[name]:""}))
                  return;
                }
            }

      if(buttonClicked==="quote_id"){
          if(name==="quote_id"){
              if(!trimValue){
                  setError((prev)=>({...prev,[name]:"Quote id is required."}))
                return;
              }
              else{
                  setError((prev)=>({...prev,[name]:""}))
                return;
              }
          }
        

      }
      else if(buttonClicked==="plate_no"){
              if(name==="registration_mark" ){
                debugger
                if(!trimValue || trimValue==="--select--"){
                  setError((prev)=>({...prev,[name]:"Registration mark is required."}))
             
                return;
                }
                else{
                  setError((prev)=>({...prev,[name]:""}));
                return;
                }
              }       
            if(name ==="registration_number"){
              if(!trimValue){
                  setError((prev)=>({...prev,[name]:"registration number is required."}));
                return;
            }
             else{
                  setError((prev)=>({...prev,[name]:""}));
                return;
                }
      }
        }
      }

        const searchQuote=async(e)=>{
        e.preventDefault();
          let valid =true;

            //check civil No

            if(!formData.civil_no){
                valid =false;
                 setError((prev)=>({...prev,civil_no:"Civil no is required."}))
                civilNoRef.current.focus();
            }

      if(buttonClicked==="quote_id"){
          if(!formData.quote_id){
             valid =false;
                 setError((prev)=>({...prev,quote_id:"Quote ID is required."}));
                 if(formData.civil_no){
                quoteRef.current.focus();
                 }
                
          }
        

      }
      else if(buttonClicked==="plate_no"){
              if(!formData.registration_mark ){
debugger
               valid =false;
                setError((prev)=>({...prev,registration_mark:"Registration mark is required."}))
                  if(formData.civil_no){
                    $(selectOpt1.current)
  .next('.select2-container')
  .find('.select2-selection')
  .trigger('mousedown');
    //              $(selectOpt1.current).select2('open');
    // $(selectOpt1.current).next('.select2-container')[0]?.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'center',
    // });
                  }
               
              }
                
            if(!formData.registration_number){
               valid =false;
                setError((prev)=>({...prev,registration_number:"Registration Number is required."}));
                if(formData.civil_no && formData.registration_mark){
                regNoRef.current.focus();
                }
            }
      }
      if(valid){
        setLoading(true);
       
           
        // write the search quote Api code 
try{

   const req_data= {
    civilId:formData.civil_no,
    plateNo: formData.registration_number || "" ,
    registrationMark:formData.registration_mark || "",
    srcBusId: "BOT",
    txnTyp:"Q",
    mobileNo:"",
    policyNo:"",
    quoteNo:formData.quote_id||"",
    searchTyp:"PS"

}
       const response =await fetch(base_url +"/search_quote",{
        method:"post",
        headers:{
            Authorization:"Bearer "+vendor_key,
            "Content-Type":"application/json"
        },
        body:JSON.stringify(req_data)
       });

       const data = await response.json();
       if(!response.ok){
            throw new Error("search quote response status : "+ response.status)
       }
       if(data.message==="success"){
        if(data.result.effectiveDt ){

          // const quote_info=data.result;
          //   const session_data={
          //     civilId:quote_info?.insuredDetails?.insuredLicNo,
          //     plateNo: quote_info?.vehicleDetails?.vehRegNo,
          //     registrationMark:quote_info?.vehicleDetails?.vehRegLOC,
          //     srcBusId: "BOT",
          //     txnTyp:"Q",
          //     mobileNo:quote_info?.insuredDetails?.insuredMobileNo,
          //     policyNo:quote_info?.renewalQuoteNo ||"107/0502/2025/Q/000742",
          //     quoteNo:""
          // }

        setQuoteDetails(data.result);
        setVehicleDetails(data.result.vehicleDetails);
        setInsuredDetails(data.result.insuredDetails);
        setTransactionDetails(data.result.transactionDetails?data.result.transactionDetails:null);
        setOpenPaymentOption(true);
        
        }
        else{
           setSubmitBtnClicked(true);
           setQuoteDetails(null);
        setVehicleDetails(null);
        setInsuredDetails(null);
        setTransactionDetails(null);
        setOpenPaymentOption(false);
        }
       }

    }
    catch(err){
        console.error("search quote err : "+err.message)
    }
    finally{
      
        setLoading(false);
    }
      }
      else{
        return;
      }
  

        }



    const makePayment=async(e)=>{

          e.preventDefault();

            const req_data={
              quoteNo:quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo,
              srcBusId:"BOT"   
            }
           try{
            const response =await fetch(base_url+"/motor_payments",{
               method:"POST",
               headers:{
                Authorization:"Bearer "+vendor_key,
                "Content-Type":"application/json"
               },
               body:JSON.stringify(req_data)
            });

            const data= await response.json();

          if (data.message === "success") {
  const payment_link = data.result.transactionDetails.pgUrl;
  const anchor = document.createElement("a");
  anchor.setAttribute("href", payment_link);
 
  anchor.click();
} 

           }catch(err){
            console.error("err at make payment api "+ err)
           }

        }


        const handleButtonClick=(e)=>{
            e.preventDefault();

            const id=e.target.getAttribute("id");

            if(id){
              const currentbtn=buttonClicked;
              if(currentbtn!==id){
               setFormData((prev)=>({
        ...prev,
        quote_id:"",
        registration_mark:"",
        registration_number:""
      }));
      setError((prev)=>({
        ...prev,
        quote_id:"",
        registration_mark:"",
        registration_number:""
      }));
    }
            setButtonClicked(id);
            }
          
        

        }
   return (
   isHidePage === 'success' ? 
          <Fragment>
              <form className="visa-form1">
                  <div style={{ display: 'flex', paddingBottom: '20px' }}>
                      <button style={{ width: '100px', fontWeight: 'bold' }}>
                          Back
                      </button>
                  </div>
                  
                 
                  <>
                  <div className="row mb-3">
                      <div className="col-md-12">
                          <div>
                              <div className="row mb-3">
                                  <div className="col-md-6 text-start">
                                      <h2>Renew Your Motor Insurance Policy</h2>
                                  </div>
                                  <div className="col-md-6 text-right">
                                    تجديد بوليصة تأمين سيارتك
                                  </div>
                              </div>
  
  
                              <div className='inside_visa-form'>
                                  <div className="row mb-2">
                          <div className='col-md-4'>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Civil no<span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>رقم مدني </span></label>


                  <input
                    type='text'
                    className='form-control'
                    ref={civilNoRef}
                    value={formData.civid_no}
                    name='civil_no'
                    onChange={handleChange}
                    onBlur={handleValidation}
                  //   onBlur={handleNameBlurtenant} // Validate on blur (when user leaves the field)
                    // onInput={(e) => {
                    //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                    // }}
                  />
                  {error?.civil_no && <p style={{ color: 'red' }}>{error?.civil_no}</p>}
                </div>
                </div>
                <div className="row mb-3">
                <div className="col-12 mt-3 mb-3">
                    <h3 className="mb-2">Dual Option Policy Renewal</h3>
                   <div className="d-flex justify-content-start">
                   <div className="border d-inline-block " style={{borderRadius: "10px"}}>
                    <button className="p-2 px-4" type="button" id="quote_id" style={{backgroundColor:buttonClicked!=="quote_id"?"white":"#007BFF",color:buttonClicked!=="quote_id"?"black":"white",borderRadius: "0px",borderTopLeftRadius:"10px",borderBottomLeftRadius:"10px"}} onClick={handleButtonClick}>Quote ID</button>
                    <button className="p-2 px-4" type="button" id="plate_no" style={{backgroundColor:buttonClicked!=="plate_no"?"white":"#007BFF",color:buttonClicked!=="plate_no"?"black":"white",borderRadius: "0px",borderTopRightRadius:"10px",borderBottomRightRadius:"10px"}} onClick={handleButtonClick}>Plate No</button>
                    </div>
                    </div>
                   
                </div>

                { buttonClicked.toLowerCase()==="quote_id" &&  <div className='col-md-4'>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>  Quote ID<span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>معرف الاقتباس </span></label>


                  <input
                    type='text'
                    className='form-control'
                    ref={quoteRef}
                    value={formData.quote_id}
                    name='quote_id'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                 {error?.quote_id && <p style={{ color: 'red' }}>{error?.quote_id}</p>}
                </div>}
                      </div>
      {buttonClicked.toLowerCase()==="plate_no"&&
              <div className='row mb-3'>
  
             <div className='col-md-4'>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>  Registration Mark<span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>علامة التسجيل  </span></label>
                 <select ref={selectOpt1}  name="registration_mark" className="form-control" value={formData?.registration_mark} 
                  onChange={handleChange}
                  onBlur={handleValidation} >
        <option value={null}>--select--</option>
        {reg_mark.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
        </select>
 {error?.registration_mark && <p style={{ color: 'red' }}>{error?.registration_mark}</p>}
               
                </div>
  
  
             <div className='col-md-4'>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>  Registration Number<span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>رقم التسجيل  </span></label>


                  <input
                    type='text'
                    ref={regNoRef}
                    className='form-control'
                    value={formData.registration_number}
                    name='registration_number'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  {error?.registration_number && <p style={{ color: 'red' }}>{error?.registration_number}</p>}
                </div>
  
                
  
              </div>
  }
  {

(buttonClicked==="quote_id"||buttonClicked==="plate_no") &&
  <div className="row">
  <button className="ml-3 mt-3 mb-3" 
  type="submit"
  onClick={(e)=>{searchQuote(e)}}
  
>
    Renew My Policy
  </button>
  </div>
  }
  
  

  
              
            </div>
            
  
  
                          </div>
                      </div>
  
                      
                  </div>
  
                      </>
                
  
       {/* all details display ; */}

       {

         
               (submitBtnClicked && !vehicleDetails && !insuredDetails) &&

                <div className="row d-flex ">
   
   <div className="col-12">
   <div className="card ">
                <div className="text-center my-5">
                  <h3>No Quote Found</h3>
                  <p>Please try again with valid details.</p>
                  </div>
                  </div>
                  </div>
                  </div>
       }
  
  
  { 
   ( openPaymentOption&& quoteDetails ) &&
       <div className="row d-flex ">
   
   <div className="col-md-6">
   <div className="d-flex justify-content-between ">
                              <h2>Vehicle Details</h2>
                              <h2>تفاصيل السيارة</h2>
                          </div>
    <div className="w-100 ">
                           <div className="card  w-100">
                            <table className="w-100 mt-3">
                            <tbody>
                             {/* model */}
                            <tr>
                           
                              <td><h5 className="pl-3"><strong>Model</strong></h5></td>
                              <td>
                             <h5>: {vehicleDetails?.make} ({vehicleDetails?.modelYear})</h5>
                              </td>
                              </tr>
  
  {/* vehicle no */}
                              <tr>
    <td><h5 className="pl-3"><strong>Vehicle No</strong></h5></td>
                                <td><h5>: {vehicleDetails?.vehRegNo} {vehicleDetails?.vehRegLOC}</h5></td>
                              </tr>
  
                              {/* chassis no */}
  
  
                                 <tr>
    <td><h5 className="pl-3"><strong>Chassis No</strong></h5></td>
                                <td><h5>: {vehicleDetails?.chasisNo}</h5></td>
                              </tr>
  
                           {/* body type  */}
  
   <tr>
    <td><h5 className="pl-3"><strong>Body Type</strong></h5></td>
                                <td><h5>: {vehicleDetails?.vehBody}</h5></td>
                              </tr>
  
                                        {/* usage type  */}
  
                            <tr>
    <td><h5 className="pl-3"><strong>Usage Type</strong></h5></td>
                                <td><h5>: {vehicleDetails?.usage}</h5></td>
                              </tr>
  
  
  
                              </tbody>
                          </table>
                          </div>
                            <div>
  
                            </div>                      
         </div>
  
       </div>
  
  <div className="col-md-6">
      <div className="d-flex justify-content-between ">
                              <h2>Insured  Details</h2>
                              <h2>تفاصيل المؤمن عليه</h2>
                          </div>
    <div className="w-100 ">
                           <div className="card  w-100">
                            <table className="w-100 mt-3">
                            <tbody>
                             {/* model */}
                            <tr>
                           
                              <td><h5 className="pl-3"><strong>Insured Name</strong></h5></td>
                              <td>
                             <h5>: {insuredDetails?.insureFullName}</h5>
                              </td>
                              </tr>
  
  {/* vehicle no */}
                              <tr>
    <td><h5 className="pl-3"><strong>Civil Id</strong></h5></td>
                                <td><h5>: {insuredDetails?.insuredLicNo}</h5></td>
                              </tr>
  
                              {/* chassis no */}
  
  
                                 <tr>
    <td><h5 className="pl-3"><strong>Age</strong></h5></td>
                                <td><h5>: {insuredDetails?.insuredAge}</h5></td>
                              </tr>
  
  
  
                              </tbody>
                          </table>
                          </div>
                            <div>
  
                            </div>                      
         </div>
  </div>
  
  <div className="col-md-12 mt-3">
      <div className="d-flex justify-content-between ">
                              <h2>Quote Details</h2>
                              <h2>تفاصيل الاقتباس</h2>
                          </div>
    <div className="w-100 ">
                           <div className="card w-100">
                            <table className="w-100 mt-3">
                            <tbody>
                             {/* model */}
                            <tr>
                              <td><h5 className="pl-3"><strong>Quote No</strong></h5></td>
                              <td>
                             <h5>: {quoteDetails?.renewalQuoteNo || transactionDetails?.quoteNo}</h5>
                              </td>
                              </tr>
  
  
  <tr>
                              <td><h5 className="pl-3"><strong>Cover From Date</strong></h5></td>
                              <td>
                             <h5>: {quoteDetails?.effectiveDt}</h5>
                              </td>
                              </tr>
  
  
                              
  <tr>
                              <td><h5 className="pl-3"><strong>Cover To Date</strong></h5></td>
                              <td>
                             <h5>: {quoteDetails?.expirationDt}</h5>
                              </td>
                              </tr>
  
  
  
  <tr>
   <td><h5 className="pl-3"><strong>Product</strong></h5></td>
                              <td>
                             <h5>: {quoteDetails?.prodId}</h5>
                              </td>
                              </tr>
  
                              <tr>
   <td><h5 className="pl-3"><strong>Plan</strong></h5></td>
                              <td>
                             <h5>: {quoteDetails?.planSelection}</h5>
                              </td>
                              </tr>
  
  
  <tr>
   <td><h5 className="pl-3"><strong>Obtained Cover</strong></h5></td>
                              <td>
                             <h5>: {quoteDetails?.packageDetails?.obtainedCvr}</h5>
                              </td>
                              </tr>
  
    
                         
                     
  
                              </tbody>
                          </table>
                          </div>
                            <div>
  
                            </div>                      
         </div>
  </div>
  <div className="col-12">
    <div className="d-flex gap-3 mt-3">
       <h2 className="mr-3">NET PREMIUM (Including VAT & all other taxes)</h2>
       <h2><strong>: {quoteDetails?.premiumAmt} OMR</strong></h2>
    </div>
  
  
    {/* make payment */}
  <button className="mb-3" 
  onClick={(e)=>{makePayment(e)}}
>
    Make Payment
  </button>
  
    </div>
      </div>
  
    }
               
    
              
          
              </form>
  {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
  
          </Fragment>
  :
  <div style={{
              width: '100vw',
              height: '100vh',
              border: 'none',
              textAlign: 'center',
              marginTop: '25%',
              fontSize: '20px',
              fontWeight: 'bold'
          }}>  {isHidePage == '' ? "Loading" : "Token Invalid"}</div>
      );
    
}

export default SanadMotorRenewPolicy;